import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class LayoutService {

    apiServer = environment.apiServer;
    constructor(private http: HttpClient) {

    }

    getNotifications() {
        return this.http.get(this.apiServer + "/notification/");
    }
}